module.exports = __webpack_public_path__ + "static/media/37.d7aa994d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/37.jpg
// module id = 406
// module chunks = 0